<template>
    <v-card :loading="loading || form.busy">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-sheet>
            <v-toolbar flat :extended="isMobileOrTablet">
                <v-btn
                    outlined
                    class="mr-4"
                    color="grey darken-2"
                    @click="setToday"
                >
                    Astazi
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    fab
                    small
                    outlined
                    color="primary darken-2"
                    class="mr-2"
                    @click="prev"
                >
                    <v-icon>
                        mdi-chevron-left
                    </v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar && !isMobileOrTablet">
                    {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-btn
                    fab
                    small
                    outlined
                    color="primary darken-2"
                    class="ml-2"
                    @click="next"
                >
                    <v-icon>
                        mdi-chevron-right
                    </v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-menu
                    v-if="!isMobileOrTablet"
                    bottom
                    right
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            outlined
                            color="grey darken-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <span>{{ typeToLabel[type] }}</span>
                            <v-icon right>
                                mdi-menu-down
                            </v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="type = 'day'">
                            <v-list-item-title>Zilnic</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="type = 'week'">
                            <v-list-item-title>Saptamanal</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="type = 'month'">
                            <v-list-item-title>Lunar</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-dialog
                    v-model="showEventDialog"
                    :max-width="isMobileOrTablet ? null : '600px'"
                    :fullscreen="isMobileOrTablet"
                    persistent
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            outlined
                            color="primary"
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                            <span v-if="!isMobileOrTablet">Adaugare</span>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span v-if="!_.isNil(form.id)" class="text-h5">Modificare eveniment</span>
                            <span v-else class="text-h5">Adaugare eveniment</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="form.name"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('name')"
                                            :class="{ 'error--text': hasErrors('name') }"
                                            class="primary--text"
                                            label="Denumire"
                                            data-vv-as="Denumire"
                                            data-vv-name="name"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-datetime-picker
                                            label="Data si ora inceput"
                                            clear-text="Renuntare"
                                            ok-text="OK"
                                            :time-picker-props="{
                                                format: '24hr'
                                            }"
                                            :text-field-props="{
                                                vValidate: 'required',
                                                errorMessages: errorMessages('start'),
                                                class: { 'primary--text': true, 'error--text': hasErrors('start') },
                                                dataVvAs: 'Data si ora inceput',
                                                dataVvName: 'start'
                                            }"
                                            v-model="form.start"
                                        ></v-datetime-picker>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-datetime-picker
                                            label="Data si ora sfarsit"
                                            clear-text="Renuntare"
                                            ok-text="OK"
                                            :time-picker-props="{
                                                format: '24hr'
                                            }"
                                            :text-field-props="{
                                                vValidate: 'required',
                                                errorMessages: errorMessages('end'),
                                                class: { 'primary--text': true, 'error--text': hasErrors('end') },
                                                dataVvAs: 'Data si ora inceput',
                                                dataVvName: 'start'
                                            }"
                                            v-model="form.end"
                                        ></v-datetime-picker>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select
                                            v-model="form.color"
                                            :items="selectColors"
                                            label="Culoare / evidentiere"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('color')"
                                            :class="{ 'error--text': hasErrors('color') }"
                                            class="primary--text"
                                            data-vv-as="Culoare / evidentiere"
                                            data-vv-name="color"
                                        >
                                            <template slot='selection' slot-scope='{ item }'>
                                                <div :class="`pa-3 mr-4 rounded-circle d-inline-block ${item.value}`"></div>
                                                {{ item.text }}
                                            </template>
                                            <template slot='item' slot-scope='{ item }'>
                                                <div :class="`pa-3 mr-4 rounded-circle d-inline-block ${item.value}`"></div>
                                                {{ item.text }}
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea
                                            v-model="form.data.description"
                                            :error-messages="errorMessages('data.description')"
                                            :class="{ 'error--text': hasErrors('data.description') }"
                                            class="primary--text"
                                            label="Descriere"
                                            data-vv-as="Descriere"
                                            data-vv-name="data.description"
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                v-if="!_.isNil(form.id) && canEdit"
                                color="red darken-1"
                                text
                                @click="dialogDelete = true"
                            >
                                Stergere
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="showEventDialog = false"
                            >
                                Inchidere
                            </v-btn>
                            <v-btn
                                v-if="canEdit"
                                :loading="form.busy"
                                :disabled="errors.any() || form.busy"
                                color="blue darken-2"
                                text
                                @click="submit()"
                            >
                                Salveaza
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <template v-if="isMobileOrTablet" v-slot:extension>
                    <v-menu
                        bottom
                        right
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                outlined
                                block
                                color="grey darken-2"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <span>{{ typeToLabel[type] }}</span>
                                <v-icon right>
                                    mdi-menu-down
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="type = 'day'">
                                <v-list-item-title>Zilnic</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'week'">
                                <v-list-item-title>Saptamanal</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'month'">
                                <v-list-item-title>Lunar</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="events"
                :event-color="getEventColor"
                :type="type"
                :locale="App.locale"
                :event-height="40"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:date="viewDay"
                @click:time="clickTime"
                @change="updateRange"
            >
                <template v-slot:event="{ event }">
                    <div class="pl-1">
                        <strong>{{ $moment(event.start).format('HH:mm') }}</strong> - {{ event.name }}<br/>
                        <span v-if="!_.isNil(_.get(event, 'created_by.name'))">
                            {{ _.get(event, 'created_by.name') }}
                        </span>
                    </div>
                </template>
            </v-calendar>
        </v-sheet>
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" :loading="loading" text @click="dialogDelete = false">Anulare</v-btn>
                    <v-btn color="blue darken-1" :loading="loading" text @click="deleteItemConfirm">Confirmare</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import validationError from "Mixins/validation-error";
import ACL from "Mixins/acl";
import {Form} from "vform";
export default {
    mixins: [validationError, ACL],
    data: () => ({
        focus: '',
        type: 'month',
        typeToLabel: {
            month: 'Lunar',
            week: 'Saptamanal',
            day: 'Zilnic'
        },
        events: [],
        loading: false,
        dialogDelete: false,
        showEventDialog: false,
        form: new Form({
            id: null,
            workstation_id: null,
            name: null,
            start: null,
            end: null,
            color: 'primary',
            timed: false,
            data: {},
            created_by: null
        }),
        originalForm: {
            id: null,
            workstation_id: null,
            name: null,
            start: null,
            end: null,
            color: 'primary',
            timed: false,
            data: {},
            created_by: null
        },
        selectColors: [{
            text: 'Standard',
            value: 'primary'
        }, {
            text: 'Rosu',
            value: 'red'
        },{
            text: 'Roz',
            value: 'pink'
        },{
            text: 'Violet',
            value: 'purple'
        },{
            text: 'Indigo',
            value: 'indigo'
        },{
            text: 'Albastru',
            value: 'blue'
        },{
            text: 'Verde',
            value: 'green'
        },{
            text: 'Galben',
            value: 'yellow'
        },{
            text: 'Portocalie',
            value: 'orange'
        }],
        filter: {
            start: null,
            end: null
        }
    }),
    computed: {
        ...mapGetters({
            getMe: "getMe"
        }),
        canEdit() {
            let eventCreatedBy = this._.get(this.form, 'created_by.id')
            let currentUserId = this.getMe.id
            return (
                eventCreatedBy === undefined ||
                this.hasAnyRole(['sef_de_unitate', 'manager']) ||
                eventCreatedBy === currentUserId
            )
        }
    },
    watch: {
        showEventDialog: {
            handler (val) {
                if (!val) {
                    this.form = new Form(this.originalForm)
                }
            }
        },
        dialogDelete (val) {
            this.dialogDelete = val
            if (!val) {
                this.showEventDialog = false
            }
        },
    },
    mounted() {
        if (this.isMobileOrTablet) {
            this.type = 'day'
        }
        this.$refs.calendar.checkChange()
        this.loadResource()
    },
    methods: {
        async loadResource(start, end, force = false) {
            if (!(start && end)) return
            if (
                this.filter.start === start &&
                this.filter.end === end &&
                !force
            ) return

            this.loading = true
            let { data, meta } = await this.$db.Appointment
                .include('createdBy')
                .page(1)
                .where('between', [start, end].join(','))
                .limit(500)
                .get()
            this.events = data
            this.loading = false
            this.filter = {
                start,
                end
            }
        },

        async deleteItemConfirm() {
            let item = (new this.$db.Appointment({id: this.form.id}))
            this.loading = true
            await item.delete()
            this.loading = false
            this.dialogDelete = false

            await this.loadResource(
                this.filter.start,
                this.filter.end,
                true
            )
        },

        async submit() {
            let self = this;
            this.$validator.validateAll().then(result => {
                if (result) {
                    // eslint-disable-next-line
                    self.createOrUpdate();
                } else {
                    this.showError()
                }
            });
        },
        async createOrUpdate() {
            let self = this;
            self.form.busy = true;

            let model = new this.$db.Appointment(self.form);
            if (this.id) {
                model.id = this.id
            }
            model.start = this.$moment(self.form.start).format('YYYY-MM-DD HH:mm:ss')
            model.end = this.$moment(self.form.end).format('YYYY-MM-DD HH:mm:ss')

            model.save()
                .then(response => {
                    self.$validator.reset();
                    this.showSuccess();
                    this.loadResource(this.filter.start, this.filter.end, true)
                    this.showEventDialog = false
                })
                .catch(errors => {
                    self.form.errors.set(this.form.extractErrors(errors.response))
                    this.showError()
                }).finally(() => {
                self.form.busy = false;
            });
        },
        viewDay({date}) {
            this.focus = date
            this.type = 'day'
        },
        getEventColor(event) {
            return event.color
        },
        setToday() {
            this.focus = ''
        },
        prev() {
            this.$refs.calendar.prev()
        },
        next() {
            this.$refs.calendar.next()
        },
        showEvent({nativeEvent, event}) {
            this.form = new Form(Object.assign({}, event, {
                start: new Date(event.start),
                end: new Date(event.end)
            }))
            this.showEventDialog = true
            nativeEvent.stopPropagation()
        },
        async updateRange({start, end}) {
            await this.loadResource(
                this.$moment(start.date).startOf('month').format('YYYY-MM-DD'),
                this.$moment(end.date).endOf('month').format('YYYY-MM-DD')
            )
        },
        clickTime({date, hour}) {
            this.form = new Form(Object.assign({}, this.originalForm, {
                start: this.$moment(date).set('hour', hour).set('minute', 0).set('second', 0).set('millisecond', 0).toDate(),
                end: this.$moment(date).set('hour', hour + 1).set('minute', 0).set('second', 0).set('millisecond', 0).toDate(),
            }))
            this.showEventDialog = true
        }
    },
};
</script>

<style lang="scss">
$calendar-event-line-height: 40px;
</style>
